import { LEGAL } from '../data/legal.js';
import { CONTACT } from '../data/contact.js';

/**
 * Shared shell for the legal pages. The page title lives in the hero, so this
 * renders the document body only: an updated date, an optional lede, the
 * numbered sections passed as children, and a consistent contact block.
 */
export default function LegalDoc({ intro, contactLead, children }) {
  return (
    <section className="section legal">
      <div className="container legal-doc">
        <p className="legal-updated">Last updated: {LEGAL.lastUpdated}</p>
        {intro ? <p className="legal-lede">{intro}</p> : null}
        {children}
        <div className="legal-contact">
          <h2>Contact us</h2>
          <p>{contactLead}</p>
          <ul className="legal-contact-list">
            <li>
              <span className="label">Business</span>
              <span className="value">{LEGAL.business}</span>
            </li>
            <li>
              <span className="label">Phone</span>
              <a className="value" href={`tel:${CONTACT.phoneTel}`}>
                {CONTACT.phoneDisplay}
              </a>
            </li>
            {LEGAL.email ? (
              <li>
                <span className="label">Email</span>
                <a className="value" href={`mailto:${LEGAL.email}`}>
                  {LEGAL.email}
                </a>
              </li>
            ) : null}
            {LEGAL.mailingAddress ? (
              <li>
                <span className="label">Mail</span>
                <span className="value">{LEGAL.mailingAddress}</span>
              </li>
            ) : null}
            <li>
              <span className="label">Facebook</span>
              <a className="value" href={CONTACT.facebookUrl} target="_blank" rel="noopener noreferrer">
                ProScape on Facebook
              </a>
            </li>
            <li>
              <span className="label">Service area</span>
              <span className="value">{CONTACT.serviceArea}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
